import { type JSX, useContext } from "react";

import { useIntlLocale } from "@frontend/hooks/useIntlLocale";
import { APIProvider, APIProviderContext } from "@vis.gl/react-google-maps";

import type { MapProviderProps } from "./MapView.types";
import { GOOGLE_MAPS_LIBRARIES, HTML_DATASET_KEY } from "./constants";

// The key is public by design (restricted by referrer on Google's side) and
// the Twig shells put it on <html>, so a page never has to pass it down.
function readApiKey(): string {
  return document.documentElement.dataset[HTML_DATASET_KEY] ?? "";
}

export function MapProvider({
  apiKey,
  language,
  region,
  children,
}: MapProviderProps): JSX.Element {
  const locale = useIntlLocale();
  const parent = useContext(APIProviderContext);

  // The Maps API loads once per page: a provider inside another one only
  // passes its children through.
  if (parent) {
    return <>{children}</>;
  }

  return (
    <APIProvider
      apiKey={apiKey ?? readApiKey()}
      libraries={[...GOOGLE_MAPS_LIBRARIES]}
      language={language ?? locale}
      region={region}
    >
      {children}
    </APIProvider>
  );
}
